var map = {
	"./1inch.svg": "26ba",
	"./ADA.svg": "da67",
	"./ALGO.svg": "6a87",
	"./ANKR.svg": "555b",
	"./AVAX.svg": "3b90",
	"./BCH.svg": "3cd4",
	"./BNB.svg": "cb7b",
	"./BNT.svg": "1f58",
	"./BTC.svg": "f885",
	"./CRV.svg": "f52f",
	"./DOGE 2.svg": "8dac",
	"./DOGE.svg": "3cc8",
	"./DOT.svg": "4d13",
	"./EOS.svg": "a296",
	"./ETH.svg": "3781",
	"./LINK.svg": "3a2a",
	"./LTC.svg": "01c3",
	"./LUNA.svg": "3b1b",
	"./MANA.svg": "5296",
	"./MATIC.svg": "95fb",
	"./NEO.svg": "e7fc",
	"./OMG.svg": "11b5",
	"./SHIB.svg": "e652",
	"./SOL.svg": "eba0",
	"./SUSHI.svg": "5d78",
	"./TRX.svg": "5015",
	"./UNI.svg": "ee64",
	"./XLM.svg": "ab69",
	"./XRP.svg": "beb8",
	"./YFII.svg": "b521",
	"./ZEN.svg": "c478",
	"./aave.svg": "242a",
	"./adx.svg": "d6f8",
	"./atom.svg": "0659",
	"./bat.svg": "72d5",
	"./btg.svg": "f61d",
	"./btt.svg": "c4cb",
	"./chz.svg": "0a1e",
	"./dash.svg": "9a6e",
	"./depositicon.svg": "b6b1",
	"./enj.svg": "0f62",
	"./etc.svg": "0383",
	"./fet.svg": "12b7",
	"./ftm.svg": "4f20",
	"./hc.svg": "0ea5",
	"./hot.svg": "561e",
	"./iota.svg": "fba1",
	"./logo.svg": "1ae4",
	"./lto.svg": "6be1",
	"./mkr.svg": "8fab",
	"./one.svg": "c4fc",
	"./ont.svg": "6113",
	"./qkc.svg": "a663",
	"./qtum.svg": "403d",
	"./rvn.svg": "d9fb",
	"./stx.svg": "b340",
	"./tfuel.svg": "9fed",
	"./theta.svg": "5151",
	"./vite.svg": "936f",
	"./waves.svg": "9e40",
	"./withdrawicon.svg": "c9e8",
	"./xem.svg": "76cb",
	"./xmr.svg": "9db4",
	"./xtz.svg": "e1ff",
	"./yfi.svg": "b918",
	"./yoyo.svg": "6c06",
	"./zec.svg": "ccb9",
	"./zil.svg": "244b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0591";